var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{ref:"wrapper",staticClass:"image-switch",style:(_vm.sliderWrapperStyle)},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_c('span',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }